/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  Text,
  TextAreaField,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { API } from "aws-amplify";
import { createStoreRecord } from "../graphql/mutations";
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function StoreRecordCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    clientId: "",
    storeId: "",
    storeName: "",
    storeNumber: "",
    toastId: "",
    timeZone: "",
    openDate: "",
    closeDate: "",
    orgLevel_1: "",
    orgLevel_2: "",
    orgLevel_3: "",
    managerUserIds: [],
    ownershipType: "",
    conceptId: "",
    tags: [],
    metadata: "",
  };
  const [clientId, setClientId] = React.useState(initialValues.clientId);
  const [storeId, setStoreId] = React.useState(initialValues.storeId);
  const [storeName, setStoreName] = React.useState(initialValues.storeName);
  const [storeNumber, setStoreNumber] = React.useState(
    initialValues.storeNumber
  );
  const [toastId, setToastId] = React.useState(initialValues.toastId);
  const [timeZone, setTimeZone] = React.useState(initialValues.timeZone);
  const [openDate, setOpenDate] = React.useState(initialValues.openDate);
  const [closeDate, setCloseDate] = React.useState(initialValues.closeDate);
  const [orgLevel_1, setOrgLevel_1] = React.useState(initialValues.orgLevel_1);
  const [orgLevel_2, setOrgLevel_2] = React.useState(initialValues.orgLevel_2);
  const [orgLevel_3, setOrgLevel_3] = React.useState(initialValues.orgLevel_3);
  const [managerUserIds, setManagerUserIds] = React.useState(
    initialValues.managerUserIds
  );
  const [ownershipType, setOwnershipType] = React.useState(
    initialValues.ownershipType
  );
  const [conceptId, setConceptId] = React.useState(initialValues.conceptId);
  const [tags, setTags] = React.useState(initialValues.tags);
  const [metadata, setMetadata] = React.useState(initialValues.metadata);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setClientId(initialValues.clientId);
    setStoreId(initialValues.storeId);
    setStoreName(initialValues.storeName);
    setStoreNumber(initialValues.storeNumber);
    setToastId(initialValues.toastId);
    setTimeZone(initialValues.timeZone);
    setOpenDate(initialValues.openDate);
    setCloseDate(initialValues.closeDate);
    setOrgLevel_1(initialValues.orgLevel_1);
    setOrgLevel_2(initialValues.orgLevel_2);
    setOrgLevel_3(initialValues.orgLevel_3);
    setManagerUserIds(initialValues.managerUserIds);
    setCurrentManagerUserIdsValue("");
    setOwnershipType(initialValues.ownershipType);
    setConceptId(initialValues.conceptId);
    setTags(initialValues.tags);
    setCurrentTagsValue("");
    setMetadata(initialValues.metadata);
    setErrors({});
  };
  const [currentManagerUserIdsValue, setCurrentManagerUserIdsValue] =
    React.useState("");
  const managerUserIdsRef = React.createRef();
  const [currentTagsValue, setCurrentTagsValue] = React.useState("");
  const tagsRef = React.createRef();
  const validations = {
    clientId: [{ type: "Required" }],
    storeId: [],
    storeName: [{ type: "Required" }],
    storeNumber: [],
    toastId: [],
    timeZone: [{ type: "Required" }],
    openDate: [],
    closeDate: [],
    orgLevel_1: [],
    orgLevel_2: [],
    orgLevel_3: [],
    managerUserIds: [],
    ownershipType: [],
    conceptId: [],
    tags: [],
    metadata: [{ type: "JSON" }],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          clientId,
          storeId,
          storeName,
          storeNumber,
          toastId,
          timeZone,
          openDate,
          closeDate,
          orgLevel_1,
          orgLevel_2,
          orgLevel_3,
          managerUserIds,
          ownershipType,
          conceptId,
          tags,
          metadata,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await API.graphql({
            query: createStoreRecord.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "StoreRecordCreateForm")}
      {...rest}
    >
      <TextField
        label="Client id"
        isRequired={true}
        isReadOnly={false}
        value={clientId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId: value,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.clientId ?? value;
          }
          if (errors.clientId?.hasError) {
            runValidationTasks("clientId", value);
          }
          setClientId(value);
        }}
        onBlur={() => runValidationTasks("clientId", clientId)}
        errorMessage={errors.clientId?.errorMessage}
        hasError={errors.clientId?.hasError}
        {...getOverrideProps(overrides, "clientId")}
      ></TextField>
      <TextField
        label="Store id"
        isRequired={false}
        isReadOnly={false}
        value={storeId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId: value,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.storeId ?? value;
          }
          if (errors.storeId?.hasError) {
            runValidationTasks("storeId", value);
          }
          setStoreId(value);
        }}
        onBlur={() => runValidationTasks("storeId", storeId)}
        errorMessage={errors.storeId?.errorMessage}
        hasError={errors.storeId?.hasError}
        {...getOverrideProps(overrides, "storeId")}
      ></TextField>
      <TextField
        label="Store name"
        isRequired={true}
        isReadOnly={false}
        value={storeName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName: value,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.storeName ?? value;
          }
          if (errors.storeName?.hasError) {
            runValidationTasks("storeName", value);
          }
          setStoreName(value);
        }}
        onBlur={() => runValidationTasks("storeName", storeName)}
        errorMessage={errors.storeName?.errorMessage}
        hasError={errors.storeName?.hasError}
        {...getOverrideProps(overrides, "storeName")}
      ></TextField>
      <TextField
        label="Store number"
        isRequired={false}
        isReadOnly={false}
        value={storeNumber}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber: value,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.storeNumber ?? value;
          }
          if (errors.storeNumber?.hasError) {
            runValidationTasks("storeNumber", value);
          }
          setStoreNumber(value);
        }}
        onBlur={() => runValidationTasks("storeNumber", storeNumber)}
        errorMessage={errors.storeNumber?.errorMessage}
        hasError={errors.storeNumber?.hasError}
        {...getOverrideProps(overrides, "storeNumber")}
      ></TextField>
      <TextField
        label="Toast id"
        isRequired={false}
        isReadOnly={false}
        value={toastId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId: value,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.toastId ?? value;
          }
          if (errors.toastId?.hasError) {
            runValidationTasks("toastId", value);
          }
          setToastId(value);
        }}
        onBlur={() => runValidationTasks("toastId", toastId)}
        errorMessage={errors.toastId?.errorMessage}
        hasError={errors.toastId?.hasError}
        {...getOverrideProps(overrides, "toastId")}
      ></TextField>
      <TextField
        label="Time zone"
        isRequired={true}
        isReadOnly={false}
        value={timeZone}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone: value,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.timeZone ?? value;
          }
          if (errors.timeZone?.hasError) {
            runValidationTasks("timeZone", value);
          }
          setTimeZone(value);
        }}
        onBlur={() => runValidationTasks("timeZone", timeZone)}
        errorMessage={errors.timeZone?.errorMessage}
        hasError={errors.timeZone?.hasError}
        {...getOverrideProps(overrides, "timeZone")}
      ></TextField>
      <TextField
        label="Open date"
        isRequired={false}
        isReadOnly={false}
        type="date"
        value={openDate}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate: value,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.openDate ?? value;
          }
          if (errors.openDate?.hasError) {
            runValidationTasks("openDate", value);
          }
          setOpenDate(value);
        }}
        onBlur={() => runValidationTasks("openDate", openDate)}
        errorMessage={errors.openDate?.errorMessage}
        hasError={errors.openDate?.hasError}
        {...getOverrideProps(overrides, "openDate")}
      ></TextField>
      <TextField
        label="Close date"
        isRequired={false}
        isReadOnly={false}
        type="date"
        value={closeDate}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate: value,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.closeDate ?? value;
          }
          if (errors.closeDate?.hasError) {
            runValidationTasks("closeDate", value);
          }
          setCloseDate(value);
        }}
        onBlur={() => runValidationTasks("closeDate", closeDate)}
        errorMessage={errors.closeDate?.errorMessage}
        hasError={errors.closeDate?.hasError}
        {...getOverrideProps(overrides, "closeDate")}
      ></TextField>
      <TextField
        label="Org level 1"
        isRequired={false}
        isReadOnly={false}
        value={orgLevel_1}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1: value,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.orgLevel_1 ?? value;
          }
          if (errors.orgLevel_1?.hasError) {
            runValidationTasks("orgLevel_1", value);
          }
          setOrgLevel_1(value);
        }}
        onBlur={() => runValidationTasks("orgLevel_1", orgLevel_1)}
        errorMessage={errors.orgLevel_1?.errorMessage}
        hasError={errors.orgLevel_1?.hasError}
        {...getOverrideProps(overrides, "orgLevel_1")}
      ></TextField>
      <TextField
        label="Org level 2"
        isRequired={false}
        isReadOnly={false}
        value={orgLevel_2}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2: value,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.orgLevel_2 ?? value;
          }
          if (errors.orgLevel_2?.hasError) {
            runValidationTasks("orgLevel_2", value);
          }
          setOrgLevel_2(value);
        }}
        onBlur={() => runValidationTasks("orgLevel_2", orgLevel_2)}
        errorMessage={errors.orgLevel_2?.errorMessage}
        hasError={errors.orgLevel_2?.hasError}
        {...getOverrideProps(overrides, "orgLevel_2")}
      ></TextField>
      <TextField
        label="Org level 3"
        isRequired={false}
        isReadOnly={false}
        value={orgLevel_3}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3: value,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.orgLevel_3 ?? value;
          }
          if (errors.orgLevel_3?.hasError) {
            runValidationTasks("orgLevel_3", value);
          }
          setOrgLevel_3(value);
        }}
        onBlur={() => runValidationTasks("orgLevel_3", orgLevel_3)}
        errorMessage={errors.orgLevel_3?.errorMessage}
        hasError={errors.orgLevel_3?.hasError}
        {...getOverrideProps(overrides, "orgLevel_3")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds: values,
              ownershipType,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            values = result?.managerUserIds ?? values;
          }
          setManagerUserIds(values);
          setCurrentManagerUserIdsValue("");
        }}
        currentFieldValue={currentManagerUserIdsValue}
        label={"Manager user ids"}
        items={managerUserIds}
        hasError={errors?.managerUserIds?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("managerUserIds", currentManagerUserIdsValue)
        }
        errorMessage={errors?.managerUserIds?.errorMessage}
        setFieldValue={setCurrentManagerUserIdsValue}
        inputFieldRef={managerUserIdsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Manager user ids"
          isRequired={false}
          isReadOnly={false}
          value={currentManagerUserIdsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.managerUserIds?.hasError) {
              runValidationTasks("managerUserIds", value);
            }
            setCurrentManagerUserIdsValue(value);
          }}
          onBlur={() =>
            runValidationTasks("managerUserIds", currentManagerUserIdsValue)
          }
          errorMessage={errors.managerUserIds?.errorMessage}
          hasError={errors.managerUserIds?.hasError}
          ref={managerUserIdsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "managerUserIds")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Ownership type"
        isRequired={false}
        isReadOnly={false}
        value={ownershipType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType: value,
              conceptId,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.ownershipType ?? value;
          }
          if (errors.ownershipType?.hasError) {
            runValidationTasks("ownershipType", value);
          }
          setOwnershipType(value);
        }}
        onBlur={() => runValidationTasks("ownershipType", ownershipType)}
        errorMessage={errors.ownershipType?.errorMessage}
        hasError={errors.ownershipType?.hasError}
        {...getOverrideProps(overrides, "ownershipType")}
      ></TextField>
      <TextField
        label="Concept id"
        isRequired={false}
        isReadOnly={false}
        value={conceptId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId: value,
              tags,
              metadata,
            };
            const result = onChange(modelFields);
            value = result?.conceptId ?? value;
          }
          if (errors.conceptId?.hasError) {
            runValidationTasks("conceptId", value);
          }
          setConceptId(value);
        }}
        onBlur={() => runValidationTasks("conceptId", conceptId)}
        errorMessage={errors.conceptId?.errorMessage}
        hasError={errors.conceptId?.hasError}
        {...getOverrideProps(overrides, "conceptId")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags: values,
              metadata,
            };
            const result = onChange(modelFields);
            values = result?.tags ?? values;
          }
          setTags(values);
          setCurrentTagsValue("");
        }}
        currentFieldValue={currentTagsValue}
        label={"Tags"}
        items={tags}
        hasError={errors?.tags?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("tags", currentTagsValue)
        }
        errorMessage={errors?.tags?.errorMessage}
        setFieldValue={setCurrentTagsValue}
        inputFieldRef={tagsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Tags"
          isRequired={false}
          isReadOnly={false}
          value={currentTagsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.tags?.hasError) {
              runValidationTasks("tags", value);
            }
            setCurrentTagsValue(value);
          }}
          onBlur={() => runValidationTasks("tags", currentTagsValue)}
          errorMessage={errors.tags?.errorMessage}
          hasError={errors.tags?.hasError}
          ref={tagsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "tags")}
        ></TextField>
      </ArrayField>
      <TextAreaField
        label="Metadata"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              clientId,
              storeId,
              storeName,
              storeNumber,
              toastId,
              timeZone,
              openDate,
              closeDate,
              orgLevel_1,
              orgLevel_2,
              orgLevel_3,
              managerUserIds,
              ownershipType,
              conceptId,
              tags,
              metadata: value,
            };
            const result = onChange(modelFields);
            value = result?.metadata ?? value;
          }
          if (errors.metadata?.hasError) {
            runValidationTasks("metadata", value);
          }
          setMetadata(value);
        }}
        onBlur={() => runValidationTasks("metadata", metadata)}
        errorMessage={errors.metadata?.errorMessage}
        hasError={errors.metadata?.hasError}
        {...getOverrideProps(overrides, "metadata")}
      ></TextAreaField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
